export default __webpack_public_path__ + "static/media/Ifood.aa0d8260.svg";